/* eslint-disable*/
import React from 'react';
import Divider from '@material-ui/core/Divider';
import image from '../images/education.jpg';

/**
 * This function renders the Education page
 * @component EducationPage
 * @return {Component} EducationPage component
 */
export default function EducationPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'white',
        border: '1px solid silver',
      }}
    >
      <div
        style={{
          flex: 1,
          width: '80%',
          margin: '30px auto',
          fontSize: '18px',
          lineHeight: '24px',
        }}
      >
        <h1
          style={{
            paddingLeft: '50px',
            marginBottom: '-40px',
            textTransform: 'uppercase',
          }}
        >
          AIS Education and Edutainment
        </h1>
        <div style={{ padding: '50px' }}>
          <Divider />
          <br />
          <p>
            The Advanced Intelligence Services Corporation offers the latest in
            basic and accelerated industry education with seminars, workshops,
            on-site training modules, and skill-building video game titles
            customized to the progressive learning objectives of your military
            or law enforcement department, agency, or branch.
          </p>
          <p>
            Our private educators are experienced, caring technology experts
            with the field competency required to bring useful, effective
            information to your organization from historic (2003), recent
            (2021), and real-time field conditions, in and beyond the United
            States of America.
          </p>
          <p>
            Many U.S. military and law enforcement professionals realize the
            growing threat of metabolic physics warfare against government and
            civilan populations, as well as the limited scope of knowledge
            sharing and learning materials supporting effective biodefense
            operations in and beyond 2021. The Advanced Intelligence Services
            Corporation is a celebrated defense contracting firm bringing safety
            to national security experts at the local, national and
            international levels through cutting-edge education.
          </p>
          <p>
            AIS Corp. understands the need to carefully safeguard identities,
            places, and schedules throughout the prep and experience of your
            selected training module. We recognize the significance of
            clandestine operating protocols before, during, and after conduct.
            From ballrooms to bodegas, we can meet your needs. Contact the
            Advanced Intelligence Services Corporation and schedule a private,
            secret, or seamless integrative educational experience based on your
            operating preferences -- not ours.
          </p>
        </div>
      </div>
      <div
        style={{
          background: `url(https://user-images.githubusercontent.com/59159608/110878681-9ffa5880-82a9-11eb-97a2-d3a9c7cd3917.png)`,
          backgroundColor: 'black',
        }}
      >
        <img style={{ width: '600px' }} src={image}></img>
      </div>
    </div>
  );
}
